<template>
    <div class="endproduktfinder" v-if="total < 1">
        <div class="container">
            <div class="row">
                <div class="ce-wrapper">
<!--                    <h3 v-if="$te('intro_headline')">{{ $t('intro_headline') }}</h3>-->
                    <p>
                        {{ $t('infotext.unavailable') }}
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div class="endproduktfinder" v-else>
        <div class="container">
            <div class="row">
                <div class="ce-wrapper">
                    <h3 v-if="$t('intro_headline')">{{ $t('intro_headline') }}</h3>
                    <p>
                        {{ infotext }}
                    </p>
                    <p v-if="kundenportal">
                        {{ $t('infotext.kundenportal') }}
                    </p>
                </div>
            </div>
        </div>
        <epf-filter/>
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <global-loading-overlay :showLoading="freeze && freeze !=='no-overlay'">
                        {{ $t('results.loading') }}
                    </global-loading-overlay>
                    <strong>{{ total }} {{ $t('results.totalResults') }}</strong>
                    <template v-if="kundenportal">
                        <kundenportal-product-combos :products="entities"/>
                    </template>
                    <template v-else>
                        <template v-for="(product, index) in entities">
                            <global-product-combo :product="product" :isFirst="index === 0" :omitDecorColum="omitDecorColum"
                                                  :omitStructureColum="omitStructureColum" :omitProductColum="omitProductColum"
                                                  :omit-application-column="omitApplicationColumn"
                                                  :omitRawboardColum="omitRawboardColum">
                                <div slot="actionArea" class="button-wrapper top right spacer--top-none">
                                    <global-button class="button--spread-xs"
                                                   :class="isInProductCombo(product.order_pid) ? 'disabled  ': ''"
                                                   @click="addToProductCombo(product.order_pid)">
                                        {{ $t('results.requestDealer') }}
                                    </global-button>
                                </div>
                            </global-product-combo>
                        </template>
                    </template>
                    <div class="button-wrapper v-center right">
                        <template v-if="(total - entities.length) > 0">
                            <span class="button-label">{{ entities.length }}&nbsp;<span>{{ $t('loadMore.of') }}</span>&nbsp;{{
                                    total
                                }}&nbsp;<span>{{ $t('loadMore.products') }}</span></span>
                            <global-button theme="secondary" @click="loadMore" :class="{'button--loading':freeze}">
                                {{ $t('loadMore.button') }}
                            </global-button>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GlobalProductCombo from "@global/global-elements/global-product-combo/global-product-combo";
import GlobalButton from "@global/global-elements/global-button/global-button";
import EpfFilter from '@epf/components/epf-filter/epf-filter';
import ProductComboMixin from "@global/mixins/productCombo";
import GlobalLoadingOverlay from "@global/global-elements/global-loading-overlay/global-loading-overlay";
import GlobalIcon from '../../../../../global/global-elements/global-icon/global-icon';
import KundenportalProductCombos from "@epf/components/kundenportal-product-combos/kundenportal-product-combos.vue";

export default {
    name: "endprodukt-finder",
    components: {KundenportalProductCombos, GlobalIcon, GlobalLoadingOverlay, EpfFilter, GlobalButton, GlobalProductCombo},
    mixins: [ProductComboMixin],
    data: function() {
        return {
            initData: {
                entities: []
            }
        }
    },
    computed: {
        omitDecorColum: function() {
            return Array.isArray(this.entities) && this.entities.length > 0 && !this.entities[0].title_d;
        },
        omitStructureColum: function() {
            return Array.isArray(this.entities) && this.entities.length > 0 && !this.entities[0].title_s;
        },
        omitProductColum: function() {
            return Array.isArray(this.entities) && this.entities.length > 0 && !this.entities[0].title_t;
        },
        omitRawboardColum: function() {
            return Array.isArray(this.entities) && this.entities.length > 0 && !this.entities[0].title_r;
        },
        omitApplicationColumn: function() {
            return Array.isArray(this.entities) && this.entities.length > 0 && !this.entities[0].recommended_application;
        },
        kundenportal: function() {
            return this.$store.state.kundenportal;
        },
        entities: function() {
            return this.$store.state.results;//initData.entities
        },
        freeze: function() {
            return this.$store.state.freeze;
        },
        total: function() {
            return this.$store.state.totalResults
        },
        infotext: function() {
            if (this.$store.state.availableFilterValues.availability.includes('order')) {
                return this.$t('infotext.availableWithOrder')
            }
            return this.$t('infotext.available')
        }
    },
    methods: {
        loadMore: function() {
            this.$store.dispatch('loadMoreResults');
        },
        // Messaging with WorkApp
        messageHandler: function(event) {
            if (event instanceof MessageEvent) {
                if (event.data.type === "pfl-endprodukt-finder") {
                    // Handle Filtering
                    // .postMessage({type: "pfl-endprodukt-finder", action: "filter", filterName: "structure", filterValue: this.structure.key.toUpperCase()})
                    if (event.data.action === "filter") {
                        // Validate filterName and filterValue
                        const filter = this.$store.getters.filterByName(event.data.filterName)
                        if (filter) {
                            const option = filter.options.find(option => option.value.localeCompare(event.data.filterValue, undefined, { sensitivity: 'base' }) === 0)
                            if (option) {
                                this.$store.dispatch('setFilterState', {filterName: filter.name, value: option.value})
                            }
                        }
                    }
                }
            }
        }
    },
    mounted() {
        this.initData = window.EPF_INITIAL

        // Messaging with WorkApp
        if (window.top) {
            window.addEventListener('message', this.messageHandler)
            this.$nextTick(() => {
                window.top.postMessage({type: "pfl-endprodukt-finder", action: "mounted"})
            })
        }
    },
    beforeDestroy() {
        if (window.top) {
            window.removeEventListener('message', this.messageHandler)
        }
    },
}
</script>
